module.exports = __webpack_public_path__ + "assets/img/utas-head-2025-nyar.png";